import React from "react";
import useInView from "../hooks/useInView";
// import { FaUserGraduate, FaChalkboardTeacher, FaRocket } from "react-icons/fa";
import careerImg from "../assets/career.png";
import '../style/animations.css';
import StarsBackground from "../backgrounds/StarsBackground";

export default function About() {
  const { ref, inView } = useInView();

  return (
    <section id="about" className="relative animated-bg py-16 md:py-24 bg-gradient-to-b from-white via-blue-50 to-purple-50">
        <div className="">
            <StarsBackground />
        </div>
      <div className="mx-auto max-w-7xl px-4 grid md:grid-cols-2 gap-12 items-center">
        
        {/* Left Content */}
        <div className={`reveal ${inView ? "in-view" : ""}`} ref={ref}>
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-pink-500">
            About Systematic Career Planner 🚀
          </h2>
          <p className="opacity-90 max-w-3xl text-gray-700 leading-relaxed">
            Systematic Career Planner (SCP) is an initiative focused on guiding students and professionals through 
            structured, well-informed career decisions. We believe time invested in career planning is as critical 
            as money invested in financial planning — a structured approach to building a successful career, just 
            like a Systematic Investment Plan builds financial wealth.
          </p>

          <div className="mt-6 grid md:grid-cols-2 gap-4">
            <div className="bg-white/80 rounded-xl p-5 shadow-sm border-l-4 border-indigo-500">
              <h3 className="font-bold text-indigo-700 mb-1">Our Mission</h3>
              <p className="text-gray-600 text-sm">To empower individuals with clarity, direction, and confidence in career decisions.</p>
            </div>
            <div className="bg-white/80 rounded-xl p-5 shadow-sm border-l-4 border-pink-500">
              <h3 className="font-bold text-pink-700 mb-1">Our Vision</h3>
              <p className="text-gray-600 text-sm">To become the most trusted platform for systematic career planning in India.</p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-10">
            {[
              {
                title: "Personalized Approach",
                copy: "Tailored programs that cater to individual needs and aspirations.",
                img: "https://cdn-icons-png.flaticon.com/512/3135/3135755.png",
              },
              {
                title: "Expert Mentors",
                copy: "Access to experienced professionals and industry experts.",
                img: "https://cdn-icons-png.flaticon.com/512/2103/2103625.png",
              },
              {
                title: "Comprehensive Coverage",
                copy: "Support from schooling to professional life, ensuring continuous growth and development.",
                img: "https://cdn-icons-png.flaticon.com/512/3135/3135823.png",
              },
            ].map((c) => (
              <div key={c.title} className="rounded-2xl bg-white hover:shadow-2xl hover:scale-105 transition-transform p-6 shadow-md flex flex-col items-center text-center">
                <img src={c.img} alt={c.title} className="w-16 h-16 mb-4" />
                {c.icon}
                <h3 className="font-semibold mb-2 text-lg">{c.title}</h3>
                <p className="opacity-80 text-sm">{c.copy}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right Futuristic Illustration */}
        <div className="flex justify-center items-center">
          <img
            src={careerImg}
            alt="Career guidance illustration"
            className="w-80 md:w-[420px] drop-shadow-2xl hover:scale-105 transition-transform"
          />
        </div>
      </div>
    </section>
  );
}
